var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.env === "uat"
        ? _c("div", { staticClass: "env-banner" }, [
            _vm._v(" Environnement de test (UAT) "),
          ])
        : _vm._e(),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }